import {useMapContext} from '@/components/MindMap/index.mjs'
import openWindow from '@/script/openWindow.mjs'

export default props => {
    const map = useMapContext()
    const {mapTypeCode} = map.data

    if ('_BF_MAP' !== mapTypeCode) {
        return null
    }

    const onClick = () => {
        const {prjId, sVer} = map.data
        const {bfName, pkid} = map.root.data

        openWindow(
            '/Ai',

            {
                bizMap: {dpId: pkid},
                prjId,
                scene: 'GENERATE_BFC',
                sVer,
                title: `业务流程: ${bfName}`,
            }
        )
    }

    return {
        label: '集成用例',
        onClick,
        ...props,
    }
}
